import { httpGet, camelify } from '@/lib/api/rest';

export function fetchIntercomData(httpGet, camelify) {
  let cache;
  return async function execute() {
    /* istanbul ignore next: development data */
    if (process.env.DEMO) return '';
    if (cache == null) {
      try {
        const { data } = await httpGet('/intercom_data');
        cache = camelify(data);
      } catch (error) {
        if (error && error.response && error.response.status === 404) return false;
        throw error;
      }
    }
    return cache;
  };
}

export default fetchIntercomData(httpGet, camelify);
